var _path, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.23904 20.0292L1.53189 19.7793L1.53189 19.7793L2.23904 20.0292ZM3.77029 21.5605L4.02016 22.2676L4.02016 22.2676L3.77029 21.5605ZM6.29287 20.6691L6.54275 21.3762L6.29287 20.6691ZM7.15819 20.7518L6.79453 21.4077L7.15819 20.7518ZM3.10106 16.5662L2.43406 16.9092L3.10106 16.5662ZM2.75002 12C2.75002 6.89137 6.89138 2.75 12 2.75V1.25C6.06295 1.25 1.25002 6.06294 1.25002 12H2.75002ZM3.76806 16.2233C3.11753 14.9581 2.75002 13.523 2.75002 12H1.25002C1.25002 13.7671 1.67699 15.4367 2.43406 16.9092L3.76806 16.2233ZM2.94619 20.2791L3.87447 17.6521L2.46017 17.1523L1.53189 19.7793L2.94619 20.2791ZM3.52041 20.8533C3.16373 20.9793 2.82016 20.6358 2.94619 20.2791L1.53189 19.7793C0.985744 21.3249 2.47457 22.8138 4.02016 22.2676L3.52041 20.8533ZM6.043 19.9619L3.52041 20.8533L4.02016 22.2676L6.54275 21.3762L6.043 19.9619ZM12 21.25C10.374 21.25 8.84799 20.8311 7.52185 20.0958L6.79453 21.4077C8.33753 22.2632 10.113 22.75 12 22.75V21.25ZM21.25 12C21.25 17.1086 17.1086 21.25 12 21.25V22.75C17.9371 22.75 22.75 17.9371 22.75 12H21.25ZM12 2.75C17.1086 2.75 21.25 6.89137 21.25 12H22.75C22.75 6.06294 17.9371 1.25 12 1.25V2.75ZM6.54275 21.3762C6.60824 21.3531 6.70012 21.3554 6.79453 21.4077L7.52185 20.0958C7.08624 19.8543 6.54891 19.7832 6.043 19.9619L6.54275 21.3762ZM2.43406 16.9092C2.48142 17.0013 2.48245 17.0893 2.46017 17.1523L3.87447 17.6521C4.04635 17.1657 3.98715 16.6494 3.76806 16.2233L2.43406 16.9092Z",
    fill: "#4F49DF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.05,
    cy: 12.0498,
    r: 1.25,
    fill: "#4F49DF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.05,
    cy: 12.0498,
    r: 1.25,
    fill: "#4F49DF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.05,
    cy: 12.0498,
    r: 1.25,
    fill: "#4F49DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChat);
export default __webpack_public_path__ + "static/media/liveChat.fb9edcc0.svg";
export { ForwardRef as ReactComponent };